// extracted by mini-css-extract-plugin
module.exports = {"fee-group":"feeGroup_fee-group__Lr6Ar","fee-group-name":"feeGroup_fee-group-name__LvJqd"};